import React from 'react';
import classNames from 'classnames';
import { XMarkIcon } from '@heroicons/react/20/solid';

export default function TagPill({
  children,
  onRemove,
  onClick,
  removeLabel,
  className = '',
  disabled = false,
}) {
  const label = typeof children === 'string' ? children : 'tag';

  return (
    <span
      className={classNames(
        'inline-flex items-center gap-x-1.5 rounded-full bg-gray-700/80 px-2.5 py-1 text-xs font-medium text-gray-100 ring-1 ring-inset ring-white/10',
        className
      )}
    >
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className="min-w-0 rounded-full text-left transition hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
        >
          {children}
        </button>
      ) : (
        <span>{children}</span>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          aria-label={removeLabel || `Remove ${label}`}
          className="-mr-0.5 inline-flex size-4 items-center justify-center rounded-full text-gray-400 transition hover:bg-white/10 hover:text-white disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
        >
          <XMarkIcon className="size-3.5" />
        </button>
      )}
    </span>
  );
}
